import HeaderMain from "../comp/head-navs-main";
import ViewContent from "../comp/view-content";
import ViewDividerSmall from "../comp/view-divider-sm";
import ViewDividerMedium from "../comp/view-divider-md";
import ViewSectionName from "../comp/view-section-name";

import RoomListModule from "../comp/room-list";

export default function Rooms() {


  return (
    <>
      <HeaderMain />
      <ViewContent 
        content={
          <>
            <ViewDividerSmall />
            <RoomListModule />

          </>
        }
      />
      

    </>
  )
}